"use client";
import React, { useCallback, useEffect, useState } from "react";
import ThemeLink from "@/components/link";
import clsx from "clsx";
import type { MenuProps } from "antd";
import { Dropdown, message } from "antd";
import { getHelpCenterLink } from "@/lib/util/get-router";
import { useUserStore } from "@/lib/store/user.store";
import { useRouter } from "next/navigation";
import { requestGetMessageUnreadCount } from "@/lib/api/message";

interface UnreadCountData {
  count?: number;
  announce?: number;
  remind?: number;
  message?: number;
}

const parseUnreadCountData = (raw: unknown): UnreadCountData => {
  if (!raw || typeof raw !== "object") return {};
  return raw as UnreadCountData;
};

const list: {
  id: number;
  title: string;
  link: string;
  isLogin?: boolean;
}[] = [
    {
      id: 1,
      title: "我的消息",
      link: "/center/message",
      isLogin: true
    }, {
      id: 2,
      title: "我的恒配达",
      link: "/"
    },
    {
      id: 4,
      title: "积分商城",
      link: "/"
    }, {
      id: 5,
      title: "帮助中心",
      link: getHelpCenterLink()
    }, {
      id: 6,
      title: "关于恒配达",
      link: "/"
    }
  ];

const myHengpeidaData: {
  title: string;
  content: { title: string; link: string, isLogin?: boolean }[];
}[] = [
    {
      title: "系统消息",
      content: [
        { title: "商城订单", link: "/center/my-order", isLogin: true },
        { title: "收藏", link: "/center/collect", isLogin: true },
        { title: "购物车", link: "/center/shopcart", isLogin: true },
      ],
    },
    {
      title: "报价管理",
      content: [{ title: "我的报价单", link: "/center/inquiry", isLogin: true }],
    },
    {
      title: "用户管理",
      content: [
        { title: "个人中心", link: "/center", isLogin: true },
        { title: "收货地址", link: "/center/address", isLogin: true },
        { title: "忘记密码", link: "/center", isLogin: true },
        { title: "会员权限", link: "/enterprise-authority" },
        { title: "账户信息", link: "/center/account-info", isLogin: true },
        { title: "账户安全", link: "/center/account-security", isLogin: true },
      ],
    },
  ];

type Props = {
  className?: string;
};

const items: MenuProps["items"] = [
  {
    key: "1",
    label: (
      <div>
        <h4 className="text-[14px] text-main">系统消息：</h4>
        <p className="text-sm text-gray-700">xxxxx</p>
      </div>
    )
  }, {
    key: "2",
    label: (
      <div>
        <h4 className="text-[14px] text-main">订单消息：</h4>
        <p className="text-sm text-gray-700">xxxxx</p>
      </div>
    )
  }
];

function PromoRight(props: Props) {
  const { userInfo } = useUserStore();
  const router = useRouter();
  const [unreadCount, setUnreadCount] = useState(0);

  const fetchUnreadCount = useCallback(async () => {
    if (!userInfo?.access_token) {
      setUnreadCount(0);
      return;
    }
    const res = await requestGetMessageUnreadCount({
      "access-token": userInfo.access_token,
    });
    if (res.code === 200) {
      const data = parseUnreadCountData(res.data);
      setUnreadCount(Number(data.count ?? 0));
    }
  }, [userInfo?.access_token]);

  useEffect(() => {
    fetchUnreadCount();
  }, [fetchUnreadCount]);

  return <>
    <ul className={clsx(props.className || "")}>
      {
        list.map(item => (
          <li key={item.id}>
            {
              item.id === 1 ? (
                <Dropdown menu={{ items }}>
                  <div onClick={() => {
                    if (item.isLogin) {
                      if (!userInfo) {
                        message.warning('请先登录');
                        return;
                      }
                    }
                    router.push(item.link);
                  }} className="text-gray-700">
                    {item.title}
                    {unreadCount > 0 ? <span className="text-main ml-0.5">({unreadCount})</span> : null}
                  </div>
                </Dropdown>
              ) : item.id === 2 ? (
                <Dropdown
                  dropdownRender={() => (
                    <div className="bg-white shadow-md rounded-md p-4 min-w-[360px]">
                      {myHengpeidaData.map((section, idx) => (
                        <div
                          key={section.title}
                          className={idx > 0 ? "mt-4 pt-4 border-t border-gray-100" : ""}
                        >
                          <h4 className="text-[14px] text-main mb-2">{section.title}：</h4>
                          <div className="grid grid-cols-3 gap-x-4 gap-y-2">
                            {section.content.map((linkItem) => (
                              <div
                                key={linkItem.title}
                                onClick={() => {
                                  if (linkItem.isLogin) {
                                    if (!userInfo) {
                                      message.warning('请先登录');
                                      return;
                                    }
                                    router.push(linkItem.link);
                                  }
                                }}
                                className="text-sm cursor-pointer text-gray-700 hover:text-main hover:underline"
                              >
                                {linkItem.title}
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                >
                  <ThemeLink href={item.link} className="text-gray-700 inline-flex items-center">
                    {item.title}
                    <i className="ri-arrow-down-s-line ml-0.5 text-[12px] text-main" />
                  </ThemeLink>
                </Dropdown>
              ) : (
                <ThemeLink href={item.link} className="text-gray-700">
                  {item.title}
                </ThemeLink>
              )
            }
          </li>
        ))
      }
    </ul>
  </>;
}

export default React.memo(PromoRight)
